/// <reference path="../../images.d.ts" />

import { Card, CardContent } from './ui/card';
import { ImageWithFallback } from './figma/ImageWithFallback';
import hdfcLogo from '../assets/e7f96baeca1911cd1cd017476f613007c3b05c05.png';
import sbiLogo from '../assets/0de0fe03b4e7e5373effc5065d44b13688631705.png';
// Removed unused imports
// import { Badge } from './ui/badge';
// import { Button } from './ui/button';
import axisLogo from '../assets/bf0dca2d4e59d3d73782444d7fd7fec6b2449c22.png';
import bluconSuperstructuresLogo from '../assets/82d4f00216f57e798656c402116d0023cf1f199e.png';
import bluconSpacesLogo from '../assets/a2c54c821cbf6bc1b2c049aecc72a14219be1915.png';
import meenakshiSuperstructuresLogo from '../assets/63cbf719e592c14705d5bac8537d630316c41ca2.png';
import { 
  Building2, 
  Banknote, 
  // Phone
} from 'lucide-react';

const PartnersSection = () => {
  const bankingPartners = [
    {
      name: "HDFC Bank",
      logo: hdfcLogo,
      description: "Benefit from flexible home loan solutions and quick processing tailored to your needs."
    },
    {
      name: "State Bank of India",
      logo: sbiLogo,
      description: "Access trusted government bank loans with wide reach and reliable service."
    },
    {
      name: "Axis Bank",
      logo: axisLogo,
      description: "Explore innovative banking solutions for a modern and seamless home financing experience."
    }
  ];

  const developmentPartners = [
    {
      name: "Blucon Superstructures",
      logo: bluconSuperstructuresLogo,
      description: "Pioneering quality construction and infrastructure development.",
      specialties: ["Commercial Construction", "Residential Projects", "Infrastructure Development"]
    },
    {
      name: "Meenakshi Superstructures",
      logo: meenakshiSuperstructuresLogo,
      description: "Crafting premium residential communities with a focus on luxury.",
      specialties: ["Residential Towers", "Villas & Gated Communities", "Urban Housing Projects"]
    },
    {
      name: "Blucon Spaces",
      logo: bluconSpacesLogo,
      description: "Transforming houses into homes with bespoke interior design.",
      specialties: ["Luxury Interiors", "Modular Kitchens", "Office Spaces"]
    }
  ];

  return (
    <section id="partners" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Banking Partners */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center mb-4">
              <div className="p-3 bg-amber-100 rounded-lg text-teal-600 mr-3">
                <Banknote className="w-6 h-6" />
              </div>
              <h3 className="text-3xl font-bold text-gray-900">Seamless Home Loans with Trusted Partners</h3>
            </div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We've partnered with leading banks to offer you pre-approved loans, competitive interest rates, and a hassle-free process, ensuring your home buying journey is smooth and secure.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {bankingPartners.map((bank, index) => (
              <Card key={index} className="border-0 shadow-lg shadow-amber-100/20 hover:shadow-xl hover:shadow-amber-100/30 transition-all duration-300 group h-full">
                <CardContent className="p-6 bg-gradient-to-br from-teal-50 via-blue-50 to-green-50 rounded-[10px] drop-shadow-md border border-teal-200 h-full flex flex-col">
                  <div className="flex items-center justify-center mb-4">
                    <div className="w-48 h-24 bg-white rounded-lg overflow-hidden shadow-sm border border-gray-100 flex items-center justify-center">
                      {bank.logo ? (
                        <ImageWithFallback 
                          src={bank.logo}
                          alt={`${bank.name} logo`}
                          className="max-w-full max-h-full object-contain p-2"
                        />
                      ) : (
                        <div className="flex items-center justify-center w-full h-full bg-gradient-to-br from-teal-50 to-teal-100">
                          <Banknote className="w-8 h-8 text-teal-600" />
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <h4 className="font-semibold text-gray-900 text-center mb-2 text-lg">{bank.name}</h4>
                  <p className="text-base text-gray-600 text-center flex-grow">{bank.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>


        </div>

        {/* Development Partners */}
        <div>
          <div className="text-center mb-12">
            <div className="flex items-center justify-center mb-4">

              <h3 className="text-3xl font-bold text-gray-900">Built on a Foundation of Trust & Expertise</h3>
            </div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
             Your home is crafted by the collective expertise of the Blucon Group.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {developmentPartners.map((partner, index) => (
              <Card key={index} className="border-0 shadow-lg shadow-amber-100/20 hover:shadow-xl hover:shadow-amber-100/30 transition-all duration-300 group">
                <CardContent className="p-6 bg-gradient-to-br from-teal-50 via-amber-50 to-teal-100 rounded-[10px] drop-shadow-md border border-teal-100">
                  <div className="flex items-center justify-center mb-4">
                    <div className="w-48 h-24 bg-white rounded-lg overflow-hidden shadow-sm border border-gray-100 flex items-center justify-center">
                      {partner.logo ? (
                        <ImageWithFallback 
                          src={partner.logo}
                          alt={`${partner.name} logo`}
                          className="max-w-full max-h-full object-contain p-2"
                        />
                      ) : (
                        <div className="flex items-center justify-center w-full h-full bg-secondary">
                          <Building2 className="w-8 h-8 text-primary" />
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <h4 className="font-semibold text-[rgba(29,31,30,1)] text-center mb-2 text-[24px]">{partner.name}</h4>
                  <p className="text-base text-gray-600 text-center mb-4 text-[14px] font-bold font-normal">{partner.description}</p>

                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;